const locale = {
  BirthDate: 'Дата рождения',
  NewPost: 'Новый пост',
  AddNews: 'Добавить новость',
  NewsText: 'Текст новости',
  Publish: 'Опубликовать',
  Cancel: 'Отмена',
  DragHereOrPressToChoose: 'Перетащите сюда файлы или нажмите чтобы выбрать',
  ChangePassword: 'Изменить пароль',
  Contact: 'Контакт',
  PhoneAdditional: 'Доп. телефон',
  Email: 'Email',
  Employees: 'Сотрудники',
  MoveDown: 'Спустить вниз',
  OUSuccessfullyMovedDown: 'Орг. единица успешно спущена вниз в структуре',
  Birthdays: 'Дни рождения',
  EmailAdditional: 'Доп. Email',
  HigherDivision: 'Вышестоящее подразделение',
  AddSubordateSubdivision: 'Добавить подчинённое подразделение',
  EditOU: 'Редактировать орг. единицу',
  CorporatePortal: 'Корпоративный портал',
  Heading: 'Заголовок',
  OUType: 'Тип орг. единицы',
  EmployeeSearchWidget: 'Виджет поиска сотрудников',
  GeneralInformation: 'Общая информация',
  Phone: 'Телефон',
  PostComment: 'Добавить комментарий',
  Today: 'Сегодня',
  SearchByFIO: 'Поиск по Ф.И.О.',
  OrgUnitSuccessfullyChanged: 'Орг. единица успешно изменена',
  OrgUnitSuccessfullyAdded: 'Орг. единица успешно добавлена',
  Description: 'Описание',
  ShowInOrgStructure: 'Отображать в орг. структуре',
  Save: 'Сохранить',
  Denomination: 'Наименование',
  OUSuccessfullyDeleted: 'Орг. единица успешно удалена',
  MoveUp: 'Поднять вверх',
  DeleteOU: 'Удалить орг. единицу',
  ResourceSuccessfullyChanged: 'Ресурс успешно изменён',
  SecurityResponsibilities: 'Охрана объектов и материальных ценностей, контроль входа/выхода ...',
  Settings: 'Настройки',
  Skills: 'Навыки',
  ResourceSuccessfullyDeleted: 'Ресурс успешно удалён',
  Edit: 'Редактировать',
  AddComment: 'Добавить комментарий',
  DeleteResource: 'Удалить ресурс',
  EventSuccessfullyAdded: 'Мероприятие успешно добавлено',
  OldPassword: 'Старый пароль',
  Login: 'Логин',
  Password: 'Пароль',
  ResetPassword: 'Сбросить пароль',
  HRDepartment: 'Отдел HR',
  TechSupportDepartment: 'Отдел технического обеспечения',
  Chancellery: 'Канцелярия',
  SubscribersDepartment: 'Абонентский отдел',
  ReceptionResponsibilities: 'Телефон приёмной генерального директора',
  ChancelleryResponsibilities: 'Входящие/исходящие документы, контроль исполнения документов ...',
  SubscribersDepartmentResponsibilities: 'Колл-центр, ведение учёта договоров ...',
  HowCanWeHelpYou: 'Чем мы можем Вам помочь?',
  FindInterestingDepartmentPhoneNumber:
    'Найдите ниже номер телефона интересующего Вас подразделения',
  ConferenceHall: 'Конференц-зал',
  Automobile: 'Автомобиль',
  ResourceSuccessfullyCreated: 'Ресурс успешно создан',
  AreYouSureToDeleteResource: 'Вы действительно хотите удалить ресурс?',
  ResourceEditing: 'Редактирование ресурса',
  ResourceAdding: 'Добавление ресурса',
  Title: 'Название',
  ResourceType: 'Тип ресурса',
  ErrorOccuredWhileAddingEvent: 'Произошла ошибка при добавлении мероприятия',
  EventSuccessfullyUpdated: 'Мероприятие успешно обновлено',
  ErrorOccuredWhileUpdatingEvent: 'Произошла ошибка при обновлении мероприятия',
  Delete: 'Удалить',
  AddOU: 'Добавить орг. единицу',
  ZoomAccount: 'Учётная запись Zoom',
  Privacy: 'Приватность',
  PubliclyAvailable: 'Общедоступное',
  AreYouSureToDeleteCalendar: 'Вы действительно хотите удалить этот календарь?',
  Add: 'Добавить',
  EditingEvent: 'Редактирование мероприятия',
  Resources: 'Ресурсы',
  MyCalendar: 'Мой календарь',
  Modules: 'Модули',
  HR: 'HR',
  Administrator: 'Администратор',
  Example: 'Пример',
  Profile: 'Профиль',
  Continue: 'Продолжить',
  Export: 'Экспорт',
  CompanyNews: 'Новости компании',
  CompanyEmployees: 'Сотрудники компании',
  YouCantDisableAllCalendars: 'Вы не можете отключить все календари',
  MyCalendars: 'Мои календари',
  AddCalendar: 'Добавить календарь',
  AddingEvent: 'Добавление мероприятия',
  AddingCalendar: 'Добавление календаря',
  EditingCalendar: 'Редактирование календаря',
  StartDateTime: 'Дата/время начала',
  FinishDateTime: 'Дата/время окончания',
  Resource: 'Ресурс',
  Members: 'Участники',
  Member: 'Участники',
  Change: 'Изменить',
  Close: 'Закрыть',
  AreYouSureToDeleteEvent: 'Вы действительно хотите удалить это мероприятие?',
  ThisMemberIsAlreadyInList: 'Этот участник уже есть в списке',
  StartDateAndTime: 'Дата и время начала',
  FinishDateAndTime: 'Дата и время окончания',
  CalendarSuccessfullyAdded: 'Календарь успешно добавлен',
  CalendarSuccessfullyDeleted: 'Календарь успешно удалён',
  Active: 'Активный',
  Download: 'Скачать',
  DocumentName: 'Название документа',
  Blank: 'Бланк',
  SelectMember: 'Выберите участника',
  NewEvent: 'Новое мероприятие',
  Reservation: 'Бронирование',
  Reference: 'Справочник',
  Adding: 'Добавление',
  Comments: 'Комментарии',
  Blanks: 'Бланки',
  SearchSubdivision: 'Поиск подразделения',
  EmployeeSuccessfullyDeleted: 'Сотрудник успешно удалён',
  Attachments: 'Вложения',
  Attachment: 'Вложениe',
  ThereAreNoUsers: 'Нет пользователей',
  RowsPerPage: 'Строк на странице',
  Roles: 'Роли',
  Users: 'Пользователи',
  User: 'Пользователь',
  UserRoles: 'Роли пользователей',
  RolesList: 'Список ролей',
  FullName: 'Полное имя',
  AddingNewReference: 'Добавление нового справочника',
  ReferenceSuccessfullyCreated: 'Справочник успешно создан',
  TableName: 'Название таблицы',
  LatinLettersAndDigits: 'Латинские символы и цифры',
  References: 'Справочники',
  Organizations: 'Организации',
  Organization: 'Организация',
  Editing: 'Редактирование',
  ShortTitle: 'Сокращённое название',
  WorkAddress: 'Рабочий адрес',
  WorkCountry: 'Страна',
  WorkCity: 'Город',
  WebPage: 'Веб-страница',
  Fax: 'Факс',
  Positions: 'Должности',
  Position: 'Должность',
  Citizenship: 'Гражданство',
  Address: 'Адрес',
  Branches: 'Отрасли',
  CollapseAll: 'Свернуть все',
  AddStaffPosition: 'Добавить штатную должность',
  AssignEmployee: 'Назначить сотрудника',
  AssignManager: 'Назначить руководителя',
  PositionSuccessfullyDeleted: 'Должность успешно удалёна',
  HrmUsers: 'Пользователи HRM',
  Confirm: 'Подтвердить',
  CalendarSuccessfullyChanged: 'Календарь успешно изменён',
  Actions: 'Действия',
  Rate: 'Ставка',
  StaffTable: 'Штатное расписание',
  RequiredField: 'Обязательное поле',
  PassportSeries: 'Серия паспорта',
  Pinfl: 'ПИНФЛ',
  Inn: 'ИНН',
  DeletePosition: 'Удалить должность',
  No: 'Нет',
  SubdivisionManager: 'Руководитель подразделения',
  AreYouSureToFireEmployeeFromPosition: 'Вы уверены, что хотите снять сотрудника с должности?',
  FireEmployeeFromPosition: 'Снять сотрудника с должности',
  SortingValue: 'Категория должности',
  Education: 'Образование',
  Responsibilities: 'Обязанности',
  AdditionalRequirements: 'Дополнительные требования',
  EmployeeSuccessfullyAssigned: 'Сотрудник успешно назначен',
  Employee: 'Сотрудник',
  PositionName: 'Название должности',
  StaffUnits: 'Штатные единицы',
  Total: 'Всего',
  ManagerSuccessfullyAssigned: 'Руководитель успешно назначен',
  CreateADUser: 'Создать пользователя AD',
  Category: 'Категория',
  Username: 'Имя пользователя',
  Search: 'Поиск',
  OUParent: 'Вышестоящее подразделение',
  ShowInOrgstructure: 'Отображать в оргструктуре',
  AreYouSureToDeleteRecord: 'Вы действительно хотите удалить запись?',
  UserSuccessfullyAdded: 'Пользователь успешно добавлен',
  Surname: 'Фамилия',
  Name: 'Имя',
  Patronymic: 'Отчество',
  PassportNumber: 'Номер паспорта',
  PhoneNumber: 'Номер телефона',
  Status: 'Статус',
  CurrentEmployee: 'Действующий сотрудник',
  Fired: 'Уволенный',
  UserStatus: 'Статус пользователя',
  Man: 'Мужчина',
  Woman: 'Женщина',
  ConnectWithHRM: 'Связать с HRM',
  AddStatus: 'Добавить статус',
  Yes: 'Да',
  SubtaskTitle: 'Название подзадачи',
  CardTitle: 'Название карточки',
  Comment: 'Комментарий',
  SuccessfullyAdded: 'Успешно добавлен',
  Executors: 'Исполнители',
  Information: 'Информация',
  InOffice: 'В офисе',
  NotInOffice: 'Не в офисе',
  Specialists: 'Специалисты',
  Management: 'Начальники',
  Managers: 'Руководители',
  TechnicalStaff: 'Технический персонал',
  AddAnotherCard: 'Добавить другую карточку',
  YouMustEnterTitle: 'Необходимо ввести название',
  ListTitle: 'Название списка',
  AddAnotherList: 'Добавить другой список',
  MakeCover: 'Сделать обложку',
  RemoveCover: 'Удалить обложку',
  RemoveAttachment: 'Удалить вложение',
  Link: 'Ссылка',
  AddItem: 'Добавьте элемент',
  WriteComment: 'Напишите комментарий',
  RemoveDueDate: 'Удалить дату выполнения',
  ChooseDueDate: 'Выбрать дату выполнения',
  SuccessfullyDeleted: 'Успешно удалён',
  Wait: 'Подождите',
  ExecutorsSelection: 'Выбор исполнителей',
  Stage: 'Этап',
  Phase: 'Фаза',
  CurrentPhase: 'Текущая фаза',
  StartDate: 'Дата начала',
  FinishDate: 'Дата окончания',
  TaskPriority: 'Приоритет задачи',
  Priority: 'Приоритет',
  Completed: 'Выполнено',
  Files: 'Файлы',
  ContractNumber: 'Номер контракта',
  ContractDate: 'Дата контракта',
  Cause: 'Основание',
  FInancing: 'Финансирование',
  Amount: 'Сумма',
  LinkedProjects: 'Связанные проекты',
  AddContract: 'Добавить контракт',
  NotSpecified: 'Не указан',
  GoToEmployeeChat: 'Перейти в чат сотрудника',
  OwnerSuccessfullyChanged: 'Владелец успешно изменён',
  ProjectBranch: 'Отрасль, в которой реализуется проект',
  FinancingSide: 'Финансирующая сторона',
  FinancingType: 'Тип финансирования',
  EditingContract: 'Редактирование контракта',
  ProjectSuccessfullyAdded: 'Проект успешно добавлен',
  ProjectSuccessfullyDeleted: 'Проект успешно удалён',
  ContractSuccessfullyDeleted: 'Контракт успешно удалён',
  EditContract: 'Редактировать контракт',
  AreYouSureToDeleteContract: 'Вы действительно хотите удалить контракт?',
  DeleteContract: 'Удалить контракт',
  Contract: 'Контракт',
  Contracts: 'Контракты',
  EmployeeSuccessfullyAdded: 'Сотрудник успешно добавлен',
  OwnerWasNotChanged: 'Владелец не был изменён',
  Attention: 'Внимание',
  AfterChangingOwnerYouWillBecomeExecutor:
    'После смены владельца Ваша роль в этом проекте автоматически изменится на Исполнителя',
  NewOwner: 'Новый владелец',
  Currency: 'Валюта',
  Sum: 'Сумма',
  DistributionByProjects: 'Распределение по проектам',
  PaymentSuccessfullyDeleted: 'Платёж успешно удалён',
  AreYouSureToDeletePayment: 'Вы действительно хотите удалить платёж?',
  Payment: 'Платёж',
  PhaseSuccessfullySaved: 'Фаза успешно сохранена',
  TaskTitle: 'Название задачи',
  TaskDescription: 'Описание задачи',
  PhaseTitle: 'Название фазы',
  AddPhase: 'Добавить фазу',
  Chapter: 'Раздел',
  InformationAboutProject: 'Информация о проекте',
  ProjectTitle: 'Название проекта',
  LinkWithOtherProjects: 'Взаимосвязь проекта с другими проектами',
  ProjectInitiator: 'Инициатор (заказчик) проекта',
  TitleAddressPhoneFaxEmail: 'наименование, ИНН, адрес, телефон, факс, e-mail',
  ProjectDescription: 'Описание проекта',
  ProjectInitiatingCause: 'Основание инициирования проекта',
  NewContract: 'Новый контракт',
  Board: 'Доска',
  Chat: 'Чат',
  ListSuccessfullyAdded: 'Список успешно добавлен',
  SubtaskSuccessfullyAdded: 'Подзадача успешно добавлена',
  ProjectEndDate: 'Дата окончания проекта',
  ProjectContents: 'Содержание проекта',
  ProjectPassport: 'Паспорт проекта',
  FillPassport: 'Заполнить паспорт',
  ProjectManager: 'Руководитель проекта',
  OfProjectGroup: 'проектной группы',
  OtherProjectMembers: 'Другие участники проекта',
  Table: 'Таблица',
  List: 'Список',
  Phases: 'Фазы',
  MyTasks: 'Мои задачи',
  Payments: 'Платёжи',
  EditProject: 'Редактировать проект',
  DeleteProject: 'Удалить проект',
  MemberSuccessfullyDeleted: 'Участник успешно удалён',
  RoleSuccessfullyChanged: 'Роль успешно изменена',
  RoleWasNotChanged: 'Роль не изменена',
  RoleInProject: 'Роль в проекте',
  MemberWasNotDeleted: 'Участник не удалён',
  ChangeOwner: 'Сменить владельца',
  PhaseSuccessfullyDeleted: 'Фаза успешно удалена',
  EditPhase: 'Редактировать фазу',
  NewPhase: 'Новая фаза',
  ListSuccessfullyRelocated: 'Список успешно перемещён',
  ErrorWhileRelocatingList: 'Ошибка при перемещении списка',
  TaskSuccessfullyRelocated: 'Задача успешно перемещёна',
  Executor: 'Исполнитель',
  AddTask: 'Добавить задачу',
  TaskSuccessfullyAdded: 'Задача успешно добавлена',
  ProjectSuccessfullyUpdated: 'Проект успешно обновлён',
  Project: 'Проект',
  ProjectEditing: 'Редактирование проекта',
  ClosedPlural: 'Закрытые',
  ExcludeMember: 'Исключить участника',
  ProjectPurposeAndExpectingResults: 'Цель и ожидаемые результаты проекта',
  NewProject: 'Новый проект',
  InWork: 'В работе',
  Paused: 'Приостановлена',
  Rejected: 'Отклонена',
  High: 'Высокий',
  Observer: 'Наблюдатель',
  AddEmployee: 'Добавить сотрудника',
  Format: 'Формат',
  Department: 'Департамент',
  Absent_plural: 'Отсутствуют',
  EmployeesSummaryReport: 'Сводная таблица по сотрудникам',
  EarlyLeaving: 'Ранний уход',
  LastWeek: 'Последняя неделя',
  LastTwoWeeks: 'Последние 2 недели',
  CreateTask: 'Создать задачу',
  ProjectStartDate: 'Дата начала проекта',
  AddProject: 'Добавить проект',
  SearchProject: 'Поиск проекта',
  Projects: 'Проекты',
  Task: 'Задача',
  New_female: 'Новая',
  Closed_female: 'Закрыта',
  Planned: 'Запланирована',
  Owner: 'Владелец',
  ResponsibleUnderContract: 'Ответственный по договору',
  Low: 'Низкий',
  Usual: 'Обычный',
  Urgent: 'Срочный',
  Responsible: 'Ответственный',
  Producer: 'Постановщик',
  ByStaff: 'По штату',
  Employees_genitive: 'Сотрудников',
  SubordinatesWorkingHoursCalculation: 'Учёт рабочего времени подчиненных',
  YouDontHaveSubordinates: 'У вас нет сотрудников в подчинении',
  FIO: 'Ф.И.О.',
  ShowTable: 'Показать таблицу',
  Lateness: 'Опоздание',
  LastThirtyDays: 'Последние 30 дней',
  LastNinetyDays: 'Последние 90 дней',
  SummaryReport: 'Сводный отчёт',
  PressButtonToCreateTask: 'Нажмите на кнопку для создания задачи',
  Gender: 'Пол',
  Departments: 'Департаменты',
  ChooseStartAndEndDatesForSummaryReport: 'Выберите дату начала и окончания для сводного отчёта',
  PreviousMonth: 'Предыдущий месяц',
  ProfilePhoto: 'Фото профиля',
  PressButtonBelowToShowTable: 'Нажмите на кнопку ниже для просмотра таблицы',
  PaymentEditingError: 'Ошибка редактирования платежа',
  Translations: ' Переводы',
  ChartsAreNotShowedInMobileDevices: 'Сегодня',
  LateComingsAndEarlyLeavings: 'Опоздания и ранние уходы',
  Dates: 'Даты',
  ViolationsCount: 'Количество нарушений',
  NoData: 'Нет данных',
  Date: 'Дата',
  Entrance: 'Вход',
  Exit: 'Выход',
  TimeAtWork: 'Время на работе',
  Calendar: 'Календарь',
  WorkingHoursCalculation: 'Учёт рабочего времени',
  Next: 'Следующий',
  NextMonth: 'Следующий месяц',
  Photo: 'Фото',
  CreationDate: 'Дата создания',
  EditContacts: 'Редактирование контактов',
  SearchEmployees: 'Поиск сотрудников',
  AddUser: 'Добавить пользователя',
  SelectUserStatus: 'Выберите статус пользователя',
  AttachedFiles: 'Прикрепленные файлы',
  AttachedFile: 'Прикрепленные файл',
  Activity: 'Активность',
  Banner: 'Баннер',
  ChangeBanner: 'Сменить баннер',
  ChangePhoto: 'Сменить фото',
  GanttChart: 'Диаграмма Ганта',
  AddPayment: 'Добавить платёж',
  Prepayment: 'Предоплата',
  PaymentSuccessfullyAdded: 'Платёж успешно добавлен',
  PaymentSuccessfullyEdited: 'Платёж успешно изменён',
  PaymentAddingError: 'Ошибка добавления платежа',
  Translation: ' Перевод',
  WorkingHoursSummaryReport: 'Сводная таблица учёта рабочего времени',
  SaveComment: ' Сохранить комментарий',
  FullscreenToggle: 'Переключатель режима полного экрана',
  SearchRole: 'Поиск роли',
  EventCreation: 'Создание мероприятия',
  OUSuccessfullyMovedUp: 'Орг. единица успешно поднята вверх в структуре',
  DoYouReallyWantToDeleteOU: 'Вы действительно хотите удалить орг. единицу?',
  SubmitYourRequest: 'Отправьте Ваш запрос',
  Support: 'Поддержка',
  YourRequestWillBeProcessed: 'Ваш запрос будет рассмотрен и наши сотрудники ответят Вам',
  Subject: 'Тема',
  Submit: 'Отправить',
  Message: 'Сообщение',
  EnterRoleForSearching: 'Введите роль для поиска',
  AddRole: 'Добавить роль',
  ClickButtonToAddRole: 'Нажмите на кнопку чтобы добавить роль',
  ReserveResource: 'Зарезервировать ресурс',
  PressAndSwipeMouseButtonDownToReserve: 'Для резервирования зажмите и проведите мышкой вниз',
  PressMouseToDate: 'Для создания мероприятия нажмите мышкой по нужной дате',
  PressHereToChangeBanner: 'Нажмите на эту кнопку чтобы сменить баннер',
  EditProfile: 'Редактировать профиль',
  PressHereToEditProfile: 'Нажмите на эту кнопку чтобы отредактировать профиль',
  PressHereToChangePassword: 'Нажмите на эту кнопку чтобы сменить пароль',
  EnterOnlyLatinLettersAndDigits: 'Вводите только латинские буквы и цифры',
  AreYouSureToDeletePosition: 'Вы уверены, что хотите удалить должность?',
  ParticipationInProjects: 'Участие в проектах',
  AreYouSureToDeleteTicket: 'Вы действительно хотите удалить тикет?',
  AreYouSureToDeleteProject: 'Вы действительно хотите удалить проект?',
  PressShiftButtonAndScrollMouseWheel: `Нажмите на кнопку для вывода сводной таблицы. Для горизонтальной прокрутки по таблице (вправо-влево) используйте сочетание клавиши 'Shift' на клавиатуре и колесика прокрутки на мышке`,
  AddSubtask: 'Добавить подзадачу',
  WrongMoneyDistributionByProjects: 'Неверно распределена сумма по проектам',
  FeedbackForm: 'Форма обратной связи',
  SearchProjects: 'Поиск проектов',
  EnterProjectNameToFindIt: 'Введите название проекта для поиска',
  Backward: 'Назад',
  Further: 'Далее',
  EditOrganization: 'Редактировать организацию',
  AddOrganization: 'Добавить организацию',
  GroupInformation: 'Информация о группе',
  ContactInformation: 'Информация о контакте',
  AddUsersToGroup: 'Добавить пользователей в группу',
  NoNews: 'Нет новостей',
  FeedbackSuccessfullyAdded: 'Ваш запрос успешно принят',
  ErrorAddingFeedback: 'Ошибка добавления запроса',
  Previous: 'Предыдущий',
  EditSkills: 'Редактировать навыки',
  HRDepartmentResponsibilities:
    'Вопросы трудоустройства, справка с работы, командировка, отпуск, больничный ...',
  AlsoProjectInitiationCauseLegalAct:
    'в т.ч. нормативно-правовой акт, являющийся основанием инициирования проекта',
  Subtasks: 'Подзадачи',
  PressHereToEditContacts: 'Нажмите на эту кнопку чтобы отредактировать контакты',
  EndDateMustBeGreaterThanStartDate: 'Дата окончания должна быть позже, чем дата начала',
  Private: 'Личный',
  Presentations: 'Презентации',
  SelectConversationOrStartNewChat: 'Выберите чат или начните новый',
  Birthday: 'День рождения',
  Send: 'Отправить',
  ParticipantsCount: 'Количество участников',
  PressHereToAddProject: 'Нажмите сюда для добавления проекта',
  ContractPayment: 'Оплата по контракту',
  ContractPrepayment: 'Предоплата по контракту',
  AdditionalAgreement: 'Дополнительное соглашение',
  AdditionalAgreements: 'Дополнительные соглашения',
  NoAdditionalAgreements: 'Нет дополнительных соглашений',
  PaymentDate: 'Дата платежа',
  AddProjectToContract: 'Добавление проекта к контракту',
  NewsSuccessfullyAdded: 'Новость успешно добавлена',
  InProgress: 'В работе',
  TasksInProgress: 'Задачи, находящиеся в работе',
  ClosedTasks: 'Выполненные задачи',
  ClosedTasksList: 'Список выполненных задач',
  PressButtonToAddContract: 'Нажмите на кнопку для добавления контракта',
  PausedTasks: 'Приостановленные задачи',
  PausedTasksList: 'Список приостановленных задач',
  RejectedTasks: 'Отклонённые задачи',
  RejectedTasksList: 'Список отклонённых задач',
  ScheduledTasks: 'Запланированные задачи',
  ScheduledTasksList: 'Список запланированных задач',
  SelectMonth: 'Выберите месяц',
  SelectMonthRestrictionsInCalendar:
    'Выберите месяц, возможны ограничения на выбор месяца в режиме календаря',
  SelectTodayButton: 'Кнопка выбора сегодняшнего дня',
  PressToJumpToday: 'Нажмите для перехода к сегодняшнему дню',
  ViewSelection: 'Выбор вида',
  SelectCalendarOfTableView:
    'Выберите вид календаря или таблицы. В режиме календаря корректно отображается текущий месяц',
  BeginAndEndDates: 'Даты начала и окончания',
  SearchDepartments: 'Поиск подразделений',
  AddingDepartment: 'Добавление подразделения',
  PressButtonForAddingDepartment: 'Нажмите на кнопку для добавления подразделения',
  EnterDepartmentForSearching: 'Введите название подразделения для поиска',
  PressButtonForAddingPosition: 'Нажмите на кнопку для добавления должности',
  WithoutViolations: 'Без нарушений',
  ClickButtonToCollapseAllDepartments: 'Нажмите на кнопку для сворачивания всех подразделений',
  AddPosition: 'Добавить должность',
  Scale: 'Масштаб',
  Day: 'День',
  Week: 'Неделя',
  Month: 'Месяц',
  Year: 'Год',
  AddingUser: 'Добавление пользователя',
  LateComingsAndEarlyLeavingsForOneWeekCharts:
    'График опозданий и ранних уходов за последнюю неделю',
  RoleTitle: 'Название роли',
  PressButtonToAddMembers: 'Нажмите на кнопку, чтобы добавить участников',
  AddMembers: 'Добавить участников',
  Latenesses: 'Опоздания',
  SendFile: 'Отправить файл',
  HorizontalScrolling: 'Горизонтальная прокрутка',
  CantCreateEventInPast: 'Невозможно создать событие за прошедшую дату/время',
  Subdivision: 'Подразделение',
  ShortName: 'Короткое наименование',
  WorkPhone: 'Рабочий телефон',
  UserSuccessfullyRemovedFromGroup: 'Пользователь успешно удалён из группы',
  ErrorRemovingUserFromGroup: 'Произошла ошибка при удалении пользователя из группы',
  ForHorizontalScrollPressShiftAndRollMouseWheel:
    'Для горизонтальной прокрутки нажмите клавишу Shift и покрутите колёсико мыши',
  ProjectOwner: 'Владелец проекта',
  Filters: 'Фильтры',
  ResetAll: 'Сбросить все',
  EndDate: 'Дата окончания',
  TicketSuccessfullySaved: 'Задача успешно сохранена',
  TicketWasntSaved: 'Задача не сохранена',
  Observers: 'Наблюдатели',
  ObserversSelection: 'Выбор наблюдателей',
  Closed: 'Закрыто',
  WorkloadIndicators: 'Показатели загруженности',
  StatisticsByTasks: 'Статистика по задачам',
  ChooseSkills: 'Выберите навыки',
  Skill: 'Навык',
  PressHereToEditSkills: 'Нажмите на эту кнопку чтобы отредактировать навыки',
  NoNotifications: 'Нет уведомлений',
  NewPlural: 'Новые',
  EventSuccessfullyDeleted: 'Событие успешно удалено',
  AreYouSureToDeleteMember: 'Вы действительно хотите удалить участника из списка?',
  FiltersAreDisabled: 'Фильтры отключены',
  StartDateCannotBeBiggerThanEndDate: 'Дата начала не может быть больше даты окончания',
  FileNotFound: 'Файл не найден',
  FileName: 'Название файла',
  AddFile: 'Добавить файл',
  DeleteFile: 'Удалить файл',
  FloorEditing: 'Редактирование этажа',
  AreYouSureToDeleteFile: 'Вы действительно хотите удалить файл?',
  MyProjects: 'Мои проекты',
  MyAttendance: 'Мои посещения',
  OnlyMembersCanChangeEvent: 'Только участники могут изменять событие',
  NoPermissionsForCreatingNewEvent: 'У Вас недостаточно полномочий для создания нового события',
  Finished: 'Завершён',
  RequestDataFromHRM: 'Запрос данных с HRM',
  ErrorOccuredOpenBrowserConsole:
    'Возникла ошибка. Для просмотра подробностей об ошибке откройте консоль браузера',
  DataSuccessfullyReceived: 'Данные успешно получены',
  DataWasNotReceived: 'Данные не были получены',
  DataSuccessfullyUpdated: 'Данные успешно обновлены',
  Mode: 'Режим',
  EditMode: 'Режим редактирования',
  Sandbox: 'Песочница',
  TechSupportDepartmentResponsibilities:
    'Сетевой, системный администратор, установка программного обеспечения...',
  Building: 'Здание',
  Buildings: 'Здания',
  Floor: 'Этаж',
  Floors: 'Этажи',
  AddDepartment: 'Добавить подразделение',
  AddBuilding: 'Добавить здание',
  AddFloor: 'Добавить этаж',
  BuildingEditing: 'Редактирование здания',
  SelectDepartments: 'Выбор подразделений',
  PleaseUploadImage1280x980pixels:
    'Пожалуйста, загрузите изображение длиной 1280 пикселей и высотой 980 пикселей!!!',
  Offices: 'Офисы',
  AddPhoto: 'Добавить фото',
  CreatorsAreAddedToMembersAutomatically:
    'Вы создатель события и будете автоматически добавлены в участники',
  EditPhoto: 'Изменить фото',
  DownloadMobileApplication: 'Скачать мобильное приложение',
  InFewDays: 'Скоро',
  BuildingsDontExist: 'Здания не добавлены',
  ChatInitialization: 'Инициализация чата',
  FloorsDontExist: 'Этажи не добавлены',
  PleaseEnterLetter: 'Пожалуйста, введите букву',
  EditFloor: 'Редактировать этаж',
  Logs: 'Логи',
  NewsSuccessfullyEdited: 'Новость успешно отредактирована',
  EditPost: 'Редактировать новость',
  Port: 'Порт',
  New: 'Новый',
  YouNeedToExecuteTheTask: 'Вам нужно выполнить задачу',
  TasksYouAreCurrentlyDoing: 'Задачи, которые вы сейчас выполняете',
  YouExecutedTasks: 'Задачи, которые вы выполнили',
  Quantity: 'Количество',
  ClaimTypes: 'Типы обращений',
  OnTime: 'Вовремя',
  AddClaimType: 'Добавить тип обращения',
  EditClaimType: 'Редактировать тип обращения',
  ClaimTypeSuccessfullyUpdated: 'Тип обращения успешно обновлён',
  ClaimTypeSuccessfullyAdded: 'Тип обращения успешно добавлен',
  ClaimTypeSuccessfullyDeleted: 'Тип обращения успешно удалён',
  AreYouSureToDeleteClaim: 'Вы действительно хотите удалить это обращение?',
  EditClaimExecutor: 'Редактировать исполнителя обращения',
  ClaimStatuses: 'Статусы обращений',
  ClaimStatusSuccessfullyDeleted: 'Статус обращения успешно удалён',
  ClaimStatusSuccessfullyUpdated: 'Статус обращения успешно обновлён',
  ClaimStatusSuccessfullyAdded: 'Статус обращения успешно добавлен',
  ClaimExecutorSuccessfullyAdded: 'Исполнитель обращения успешно добавлен',
  ClaimExecutorSuccessfullyUpdated: 'Исполнитель обращения успешно обновлён',
  ClaimExecutorSuccessfullyDeleted: 'Исполнитель обращения успешно удалён',
  AddClaimExecutor: 'Добавить исполнителя обращения',
  ClaimSuccessfullyExecuted: 'Обращение успешно исполнено',
  ClaimExecutors: 'Исполнители обращений',
  ClaimType: 'Тип обращения',
  Type: 'Тип',
  Guid: 'GUID',
  NoTemplateFields: 'Нет полей шаблона',
  Execute: 'Исполнить',
  Reject: 'Отклонить',
  CloseWindow: 'Закрыть окно',
  SuccessfullySaved: 'Успешно сохранено',
  Defer: 'Отложить',
  StartExecution: 'Взять на исполнение',
  ClaimsProcessing: 'Обработка запросов',
  ClaimProcessing: 'Обработка запроса',
  Creator: 'Создатель',
  MyEntriesAndExits: 'Мои входы/выходы',
  AddProjectStatus: 'Добавить статуса проекта',
  DoesNotExistInHRM: 'Пользователь не найден в списке HRM',
  YouDontHaveClaims: 'У вас нет обращений',
  InExecution: 'На исполнении',
  OnAgreement: 'На согласовании',
  OnApproval: 'На утверждении',
  Defered: 'Отложен',
  Closed_male: 'Закрыт',
  CleanFilters: 'Очистить фильтры',
  ImpossibleToIdentify: 'Невозможно идентифицировать',
  Filter: 'Фильтр',
  NoClaims: 'Нет заявок',
  Content: 'Содержание',
  Greeting: 'Приветствую',
  Start_verb: 'Начать',
  All: 'Все',
  ForwardToNewAchievements: 'Вперед к новым свершениям',
  PhotoNotFound: 'Фото не найдено',
  GladToSeeYouInOurTeam: 'Рады видеть Вас в нашей команде',
  YourEnergyAndTalentWillBecomeContribution:
    'Ваша энергия и талант станут бесценным вкладом в наше общее дело',
  PhotoSuccessfullyUpdated: 'Фото успешно обновлено',
  HrmEmployees: 'Сотрудники HRM',
  ConnectWithUser: 'Связать с пользователем',
  UpdatePhotoFromHrm: 'Обновить фото с HRM',
  LinkedWithUsers: 'Связанные с пользователями',
  AdUsers: 'Пользователи AD',
  Сomplaint: 'Жалоба',
  QuestionToGeneralDirector: 'Вопрос генеральному директору',
  PortalTechSupport: 'Тех. поддержка портала',
  NotLinked: 'Не связанные',
  Linked: 'Связанные',
  AdUser: 'Пользователь AD',
  LateComingsAndEarlyLeavingsCharts: 'Опоздания и ранние уходы',
  SelectRoles: 'Выберите роли',
  Reply: 'Ответить',
  FileSuccessfullyDeleted: 'Файл успешно удалён',
  TaskName: 'Название задачи',
  UnbindFromAdAccount: 'Отвязать от учётной записи AD',
  AreYouSureToUnbindEmployeeFromAdAccount:
    'Вы уверены, что хотите отвязать сотрудника от учётной записи AD?',
  AdAccountSuccessfullyUnbinded: 'Аккаунт AD успешно отвязан',
  ConnectWithAdAccount: 'Связать с учётной записью AD',
  HappyBirthday: 'С днём рождения',
  SelectPhase: 'Выберите фазу',
  TaskNumberCopiedToClipboard: 'Номер задачи скопирован в буфер обмена',
  TaskNumber: 'Номер задачи',
  PressToCopy: 'Нажмите для копирования',
  Follow: 'Перейти',
  ThereAreNoEmployees: 'Нет сотрудников',
  FirstEntranceInADay: 'Первый вход за указанный день',
  LastExitInADay: 'Последний выход за указанный день',
  PressOnDateButton: 'Нажмите на кнопку с датой',
  ForDetailedView: 'для подробного просмотра',
  Text: 'Текст',
  FirstEntrance: 'Первый вход',
  LastExit: 'Последний выход',
  DirectSubordination: 'Прямое подчинение',
  ChangeProjectOwner: 'Сменить владельца проекта',
  NoRecordsForThatDay: 'Нет записей за этот день',
  PressOnRequiredDate: 'Нажмите на требуемую дату',
  GroupName: 'Название группы',
  Vacation: 'Отпуск',
  SickLeave: 'Больничный',
  MyClaims: 'Мои заявки',
  AbsenceAsksStatuses: 'Статусы отпрашиваний',
  AddAbsenceAskStatus: 'Добавить статус отпрашивания',
  EditAbsenceAskStatus: 'Редактировать статус обращения',
  AbsenceAsksCategories: 'Категории отпрашиваний',
  AddAbsenceAskCategory: 'Добавить категорию отпрашивания',
  EditAbsenceAskCategory: 'Редактировать категорию отпрашивания',
  AbsenceAsksStatusSuccessfullyUpdated: 'Статус отпрашивания успешно изменён',
  AbsenceAsksStatusSuccessfullyAdded: 'Статус отпрашивания успешно добавлен',
  AbsenceAsksCategorySuccessfullyUpdated: 'Категория отпрашивания успешно изменёна',
  AbsenceAsksCategorySuccessfullyAdded: 'Категория отпрашивания успешно добавлена',
  AbsenceAsksSubCategories: 'Подкатегории отпрашиваний',
  AbsenceAskSuccessfullyAdded: 'Отпрашивание успешно добавлено',
  PositionCategory: 'Категория должности',
  FromTime: 'С какого времени',
  ToTime: 'По какое время',
  Approve: 'Подтвердить',
  From: 'С',
  Until: 'По',
  Chief: 'Руководитель',
  Subcategory: 'Подкатегория',
  AddAbsenceAskSubcategory: 'Добавить подкатегорию отпрашивания',
  EditAbsenceAskSubcategory: 'Редактировать подкатегорию отпрашивания',
  AbsenceAskSubcategorySuccessfullyUpdated: 'Подкатегория отпрашивания успешно изменёна',
  AbsenceAskSubcategorySuccessfullyAdded: 'Подкатегория отпрашивания успешно добавлена',
  StartDateCanNotBeLaterThanEndDate: 'Дата завершения не может быть больше даты начала',
  YouCanCreateLeaveRequestOnlyForThreeDays:
    'Можно создать запрос на отпрашивание только на 3 дня вперёд',
  FillNewsText: 'Заполните текст новости',
  NewsSuccessfullyDeleted: 'Новость успешно удалена',
  NewTasks: 'Новые задачи',
  ThereAreThreeDaysIntervalFromCurrentDate:
    'Дата начала отпрашивания не может отличаться более, чем на 3 дня от текущей даты',
  NoRecordsForSelectedTimeInterval: 'Нет записей за выбранный временной интервал',
  TasksList: 'Список задач',
  DataNotFound: 'Данные не найдены',
  NoPermissionsForCreatingNewRecord: 'У Вас недостаточно полномочий для создания новой записи',
  RecordSuccessfullyAdded: 'Запись успешно добавлена',
  ErrorOccuredWhileAddingRecord: 'Произошла ошибка при добавлении записи',
  OnlyMembersCanChangeRecord: 'Только участники могут изменять запись',
  RecordSuccessfullyUpdated: 'Запись успешно обновлена',
  ErrorOccuredWhileUpdatingRecord: 'Произошла ошибка при обновлении записи',
  CantCreateRecordInPast: 'Невозможно создать запись на прошедшую дату',
  RecordSuccessfullyDeleted: 'Запись успешно удалена',
  ManagerName: 'Руководитель',
  WorkloadByTasks: 'Загруженность по задачам',
  Attendance: 'Посещаемость',
  TaskSuccessfullySaved: 'Задача успешно сохранена',
  ErrorWhileSavingTask: 'Ошибка при сохранении задачи',
  YouHaveNoCalendarsYet: 'У вас нет ни одного календаря. Создайте календарь, пожалуйста.',
  ChooseCalendarIfNoCalendarCreateIt: 'Выберите календарь. Если нет календаря - создайте его.',
  TopManager: 'Топ-менеджер',
  TopManagerSecretary: 'Секретарь топ-менеджера',
  AddTopManagerAndSecretary: 'Добавить топ-менеджера и секретаря',
  NotAssigned: 'Не назначен',
  Secretary: 'Секретарь',
  ChooseSecretary: 'Выбрать секретаря',
  ChooseTopManager: 'Выбрать топ-менеджера',
  TopManagers: 'Топ-менеджеры',
  MyAppointments: 'Мои записи на приём',
  Appointments: 'Записи на приём',
  Time: 'Время',
  View: 'Просмотр',
  'Rad qilish': 'Отклонить',
  Waiting: 'Ожидание',
  ApproveAppointment: 'Подтверждение записи на приём',
  EnterAppointmentWaitingReason: 'Введите причину перевода записи на приём в режим ожидания',
  RejectAppointment: 'Отклонить запись',
  EnterAppointmentRejectReason: 'Введите причину отклонения записи на приём',
  Reason: 'Причина',
  SendToReApprovement: 'Отправить на пересогласование',
  EnterAppointmentReApprovementReason: 'Введите причину отправки записи на пересогласование',
  StatusSetToOnApproval: `Установлен статус 'На подтверждении'`,
  WaitingMode: 'Режим ожидания',
  NoFiles: 'Нет файлов',
  AddFiles: 'Добавить файлы',
  Claim: 'Заявка',
  AreYouSureToDeleteMessage: 'Вы точно хотите удалить это сообщение?',
  AreYouSureToDeleteChat: 'Вы точно хотите удалить этот чат?',
  edited: 'изменено',
  AndLeftGroup: 'И покинуть группу',
  NotFound: 'Не найдено',
  AttachFile: 'Прикрепить файл',
  ProjectStatuses: 'Статусы проектов',
  ProjectStatusSuccessfullyDeleted: 'Статус проекта успешно удален',
  AreYouSureToDeleteProjectStatus: 'Вы точно хотите удалить статус проекта?',
  EditProjectStatus: 'Редактировать статус проекта',
  ProjectStatusSuccessfullyUpdated: 'Статус проекта успешно изменён',
  ProjectStatusSuccessfullyAdded: 'Статус проекта успешно добавлен',
  Unknown: 'Неизвестный',
  MaxFileSizeExceeded: 'Превышен допустимый размер файла',
  AddingVideoConference: 'Добавление видеоконференции',
  Join: 'Присоединиться',
  Stop: 'Остановить',
  EditingVideoConference: 'Редактирование видеоконференции',
  ErrorOccuredWhileCreatingVideoconference: 'Произошла ошибка при создании видеоконференции',
  NoTasks: 'Нет задач',
  SearchByTask: 'Поиск по задаче',
  EarlyLeavingAndLatenesses: 'Ранние уходы и опоздания',
  LateComeAndEarlyLeavings: 'Опоздания и ранние уходы',
  LateComeAndEarlyLeaving: 'Опоздания и ранние уходы',
  Statistics: 'Статистика',
  ChooseAnotherFile: 'Выберите другой файл',
  IfNecessary: 'Если необходимо',
  File: 'Файл',
  FileNotSelected: 'Файл не выбран',
  EditFile: 'Редактировать файл',
  AddClaim: 'Добавить заявку',
  MemoryAndHonors: 'Память и почести',
  InvalidEmailFormat: 'Неверный формат электронной почты',
  Values: 'Ценности',
  Subtask: 'Подзадача',
  AddLogo: 'Добавить логотип',
  Faithful: 'Люди история',
  AreYouSureToDeleteSkill: 'Вы точно хотите удалить этот навык?',
  AreYouSureToDeleteNews: 'Вы уверены, что хотите удалить новость?',
  ChooseFile: 'Выберите файл (мах. {{size}}МБ)',
  DocumentSize: 'Размер документа',
  NoContracts: 'Нет контрактов',
  TaskNotFoundMightBeChanged: 'Извините, данная задача уже не существует',
  Open: 'Открыть',
  TaskDetails: 'Детали задачи',
  ScanApplicationDomain: 'Отсканировать домен приложения',
  AfterDownloading: 'После скачивания',
  ScanUsingUportalApp: 'Отсканируйте с помощью приложения uPortal',
  AddPhoneType: 'Добавить тип номера',
  phoneTypes: 'Типы номеров',
  InvalidPhoneNumberFormat: 'Неверный формат номера телефона, попробуйте  +998XXYYYYYYY',
  PhoneRequired: 'Необходимо ввести номер телефона',
  OnlyDigits: 'Доступны только цифры',
  MinSevenDigits: 'Минимум 7 цифр требуется',
  EnterValidEmail: 'Введите корректный адрес эл. почты',
  TheMessageFieldIsRequired: 'Поле содержание обязательно для заполнения',
  MyAppointmentFormCategoryValidation: 'Выбор категории обязателен',
  TheSubjectFieldIsRequired: 'Поле тема обязательно для заполнения',
  LeaveComment: 'Оставьте комментарий',
  ChooseDate: 'Выберите дату',
  ChooseSubcategory: 'Выберите подкатегорию',
  DeleteGroupAndLeftGroup: 'Вы уверены, что хотите покинуть эту группу?',
  DeleteChat: 'Вы уверены, что хотите удалить чат?',
  e: 'e',
  'Project management': 'Управление проектом',
  Appointment: 'Встреча',
  TypeIsAlreadyInUse: 'Тип уже используется',
  EmptyInput: 'Заполните поле',
  TypeIsAlreadyInUse1212121212: 'ewfe',
  AreYouSureToDeleteTranslation: 'Вы уверены, что хотите удалить перевод?',
  TranslationSuccessfullyDeleted: 'Перевод успешно удалён',
  TypeIsAlreadyInUse12121212121212121212: 'ffgfdg',
  TypeIsAlreadyInUse12: 'TypeIsAlreadyInUse12',
  EnterAValidURL: 'Введите корректный URL',
  HelpDesk: 'Служба поддержки',
  EnterAValidPhoneNumber: 'Введите корректный номер телефона',
  Security: 'Безопасность',
  Notifications: 'Уведомления',
  AreYouSureToDeleteBuilding: 'Вы хотите удалить это здание',
  AreYouSureToDeleteFloor: 'Вы хотите удалить этот этаж',
  YouDonTSubmitSymbolOrEmptySpace: 'Название группы должно начинаться с буквы',
  AreYouSureToDeleteTopManager: 'Вы хотите удалить этого топ-менеджера',
  ThisRoleAlreadyExist: 'Эта роль была создана ранее',
  AreYouSureToDeletePhase: 'Вы уверены, что хотите удалить фазу?',
  InvalidDate: 'Укажите полную дату',
  NoPosition: 'Нет должности',
  NoDepartment: 'Нет отдела',
  EndEvent: 'Завершить',
  CodeAlreadyExists: 'Этот код уже существует',
  isActiveAD: 'Активный AD',
  NoConferences: 'Нет конференций',
  Code: 'Код',
  SelectDateRange: 'Выберите диапазон дат',
  NoOptions: 'Ничего не найдено',
  FloorOrder: 'Порядок этажей',
  StatusRequired: 'Выберите статус',
  Assignee: 'Ответственный',
  StartEndTimeError: 'Время окончания должно быть позже времени начала',
  Unavailablefiletype: 'Этот тип файла не поддерживается',
  NoBuilding: 'Нет здания',
  Reception: 'Приём',
  Column: 'Колонка',
  HelpForWork: 'Справка для работы',
  NoFloor: 'Нет этажа',
  Rename: 'Переименовать',
  ChooseDepartments: 'Выберите отделы',
  SkillImageIsRequired: 'Загрузка изображения обязательна',
  Create: 'Создать',
  RenameGroup: 'Переименовать название группы',
  FailedToUpdateGroupName: 'Не удалось обновить название группы',
  GroupNameUpdatedSuccessfully: 'Название группы успешно обновлено',
  VideoCall: 'Видеозвонок',
  CannotSendSpace: 'Нельзя отправить только пробел',
  Ended_female: 'Завершена',
  NoDepartments: 'Департаментов нет',
  ProjectDirector: 'Директор проекта',
  NoProject: 'Нет проекта',
  Location: 'Местоположение',
  ConferenceSuccessfullyStoped: 'Конференция успешно завершена',
  NotActiveHRM: 'Не активный HRM',
  ActiveHRM: 'Активный HRM',
  NoDataAvailable: 'Информация не найдена',
  NoClaimExecuters: 'Нет исполнителя',
  InvitationToVideoConference: 'Приглашение на видеоконференцию',
  Videoconferences: 'Видеоконференции',
  Videoconference: 'Видеозвонок',
  Loading: 'Загружается',
  FilterEnabled: 'Фильтрация включена',
  FilterDisabled: 'Фильтры отключены',
  StatusRejected: 'Отклоненный',
  AreYouSureToDeleteAppointmentType: 'Вы действительно хотите удалить этот тип приёма',
  Manager: 'Менеджер',
  Approved: 'Одобренный',
  CreatedDate: 'Дата создания',
  RoleSuccessfullyDeleted: 'Роль успешно удалена',
  RoleSuccessfullyAdded: 'Роль успешно добавлена',
  Error: 'Ошибка',
  Excusme: 'Извините',
  AnErrorOccurred: 'Произошла ошибка',
  AnUnexpectedErrorOccurredInTheSystem: 'В системе произошла непредвиденная ошибка',
  ReturnToTheHomepage: 'Вернуться на главную страницу',
  UserRoleNot: 'У вас недостаточно полномочий для работы в системе. Обратитесь к администратору',
  ClaimId: 'Id заявки',
  AreYouSureToDeleteRole: 'Вы уверены, что хотите удалить роль?',
  MyAppointmentReason: 'Причина',
  MyAppointmentGoal: 'Цель',
  ErrorWhileSaving: 'Этот сотрудник уже является топ-менеджером.',
  ErrorWhileRelocatingTask:
    'Чтобы закрыть задачу, если у нее есть подзадача, необходимо сначала закрыть ее.',
  'StaffId already taken': 'Пользователь с этим идентификатором уже подключен.',
  ThisEmloyeAlreadyAssignedUser: 'Этот сотрудник уже привязан к пользователю',
  Sender: 'Отправитель',
  Print: 'Печать',
  IncomingDocuments: 'Входящие документы',
  ChooseApplication: 'Выберите тип заявления',
  CreateApplication: 'Создать заявление',
  Published: 'Опубликован',
  Back: 'Назад',
  NotPublished: 'Не опубликован',
  TemplateSuccessfullyCreated: 'Шаблон успешно создан',
  ToWhomIsAddressed: 'Кому адресуется',
  Application: 'Заявление',
  ApplicationBody: 'Тело заявки',
  DocumentDate: 'Дата документа',
  ApproversList: 'Список согласующих',
  ApproverSignature: 'Подпись согласующего',
  TextField: 'Текстовое поле',
  SelectFromList: 'Выберите из списка',
  Number: 'Число',
  RejectTemplate: 'Отклонить шаблон',
  EnterTemplateRejectReason: 'Введите причину отклонения шаблона',
  ApproversSignatures: 'Подписи согласующих',
  UnPublish: 'Отменить публикацию',
  PropertiesEditor: 'Редактор свойств',
  FieldName: 'Название поля',
  ContentType: 'Тип содержимого',
  Automatic: 'Автоматический',
  ManualInput: 'Ручной ввод',
  Contents: 'Содержимое',
  EnterText: 'Введите текст',
  AddControl: 'Добавить контрол',
  AddTag: 'Добавить тег',
  TextStyle: 'Стиль текста',
  AlignmentOnPage: 'Выравнивание на странице',
  FieldVisibility: 'Видимость поля',
  ElementsOfList: 'Элементы списка',
  AddElement: 'Добавить элемент',
  SelectFormElementToEdit: 'Выберите элемент формы для редактирования',
  SavingTemplate: 'Сохранение шаблона',
  TemplateName: 'Название шаблона',
  EnterTemplateName: 'Введите название шаблона',
  MyApplications: 'Мои заявления',
  Executed: 'Выполнены',
  Tags: 'Теги',
  ScanQRCodeForSignature: 'Отсканируйте QR-код для подписи',
  DocumentHasBeenSigned: 'Документ был подписан',
  NotRequiredField: 'Необязательное поле',
  Rejected_male: 'Отклонён',
  AddTemplateCategory: 'Добавление категории шаблона',
  EditTemplateCategory: 'Изменить категорию шаблона',
  AppointmentTypes: 'Категории записи на приём',
  TemplateCategories: 'Категории шаблонов документов',
  TemplateCategorySuccessfullyAdded: 'Категория шаблона успешно добавлена',
  TemplateCategorySuccessfullyUpdated: 'Категория шаблона успешно обновлена',
  TemplateCategorySuccessfullyDeleted: 'Категория шаблона успешно удалена',
  PrintDocuments: 'Печать документов',
  EnterValue: 'Введите данные',
  ResponsiblePerson: 'Ответственное лицо',
  Valuess: 'Значения',
  AreYouSureToDeleteTag: 'Вы действительно хотите удалить этот тег',
  Assignments: 'подписи',
  Value: 'Значение',
  PendingExecution: 'В ожидании',
  DocumentTemplateExecutors: 'Исполнители шаблонов документов',
  AddTemplateExecutor: 'Создать исполнителя шаблона документа',
  EditTemplateExecutor: 'Редактировать исполнителя шаблона документа',
  DocumentTemplateExecutorSuccessfullyDeleted: 'Исполнитель шаблона документа успешно удалён',
  NoDocumentTemplateExecuters: 'Нет исполнителей шаблонов документов',
  TemplateCategory: 'Категория шаблона',
  Emojis: 'Эмодзи',
  AreYouSureToDeleteEmoji: 'Вы действительно хотите удалить этот эмодзи',
  NoComments: 'Комментариев нет',
  OneComment: 'Комментарий',
  CommentsFew: 'Комментария',
  CommentsMany: 'Комментариев',
  ReactedByYou: 'Понравилось',
  Like: 'Поставьте реакцию',
  InProgressDocuments: 'На исполнении',
  TopReport: 'Отчет по посещаемости ТОП-менеджмента',
  AreYouSureToDeleteComment: 'Вы хотите удалить комментарий?',
  DocumentSuccessfullyRejected: 'Документ успешно отменён',
  StartDiscussion: 'Начните обсуждение',
  Expand: 'Показать полностью',
  Hide: 'Скрыть',
  ClientOrganization: 'Заказчик',
  Fulfilled: 'Исполненные',
  DocumentSuccessfullyFulfilled: 'Документ успешно выполнен',
  Team: 'Команда',
  PurposeOfProject: 'Цель проекта',
  AcceptDate: 'Запрос за этот день',
  ChooseExactDate: 'Выберите точную дату для запроса',
  getAttendanceByDatetime: 'Получить посещаемость по дате',
  AttendanceDataRequestedWait5Minutes: 'Запрошены данные о посещаемости. Подождите 5 минут.',
  EmployeesSome: 'Сотрудника',
  EmployeesMuch: 'Сотрудников',
  EmployeeSearch: 'Поиск сотрудника',
  NoEmployees: 'Нет Сотрудников',
  MyDrive: 'Мой диск',
  ProjectTitleRu: 'Наименование проекта (на русском)',
  ProfileSessions: 'Активные сессии',
  DeviceType: 'Тип устройства',
  IpAddress: 'IP-адрес',
  TimeOfLogin: 'Время входа в систему',
  Sessions: 'Сессии',
  ProjectTitleUz: 'Наименование проекта (на узбекском)',
  Reaction: 'Реакция',
  NoReaction: 'Нет реакции',
  Reactions: 'Реакции',
  More: 'Больше',
  FolderCreate: 'Создать папку',
  FileAdd: 'Добавить файл',
  RecycleBin: 'Корзина',
  FolderIsEmpty: 'Эта папка пуста',
  ReasonsForInitializingOfBussiness:
    'Причины инициирования проекта, указываются причины и обстоятельстваприведшие к инициированию проекта.',
  FolderName: 'Имя папки',
  EditFolder: 'Редактировать папку',
  CreateNewFolder: 'Создать новую папку',
  Selected: 'Выбранные',
  Share: 'Поделиться',
  новый: 'новый',
  ShowMore: 'Загрузить еще',
  BusinessOrOtherReasonsForInitiatingTheProject: 'Бизнес- или другие причины инициирования проекта',
  ProjectBudget: 'Бюджет проекта',
  CriteriaForAchievingProjectGoals:
    'Критерии достижения целей проекта (измеримые критерии достижения целей проекта)',
  ProjectFullfilmentCriteria:
    'Критерии достижения целей проекта, указываются измеримые критерии, выполнение                   которых будет способствовать достижению поставленных целей проекта.',
  ProjectBoundaries: 'Границы проекта (описание работ, включенных в проект)',
  ProjectBoundariesDetails:
    'Границы проекта, детализировано описываются работы, включенные в проект, в том                   числе прописываются работы (задачи), которые не реализуются в рамках проекта.',
  ProjectLimitations: 'Ограничения проекта',
  LimitationProjectsDescription:
    'Описание факторов, ограничивающих исполнение проекта (правовые, финансовые,                   ресурсные, календарные, а также накладываемые другими проектами и т.д.',
  ProjectAssumptions: 'Допущения проекта',
  AlternativeOptionsForProjectImplementationMechanisms:
    'Альтернативные варианты механизмов реализации проекта',
  ExpectedRisksOfTheProject: 'Ожидаемые риски проекта',
  Interdepartmental: 'Межведомственная',
  SpecificationUsedBySeveralOrgs:
    'Указывается в случае если система используется несколькими организациями',
  UsageOfPersonalData: 'Использование персональных данных',
  SystemStorageIdentication: 'Указывается если в системе используются/хранятся персональные данные',
  ReadySolutionSystem: 'Существующая система (готовое решение)',
  SolutionProvider: 'Поставщик решения',
  ProviderInfoNumber:
    'Указываются контактные данные поставщика решения, полное юридическое                   наименование, ИНН (идентификационный номер налогоплательщика), юридический и                   фактический адреса в формате: страна, область, индекс, район, город, улица, дом,                   контактные номера телефонов и факса в международном формате: (+ 998 ХХ ХХХ-ХХ-ХХ),                   адрес электронной почты',
  ConfidentinalInfo: 'Конфиденциальная информация',
  ContainsClosedDataType:
    'Указывается если в системе размещаются данные закрытого типа (ДСП и т.д.)',
  UniqueIdentifier: 'Уникальный идентификатор',
  IssuedConclusion: 'Орган, выдавший заключение',
  PurposeOfTheConclusion: 'Назначение заключения',
  ConclusionNumber: 'Номер заключения',
  DateOfConclusion: 'Дата заключения',
  ConclusionFiles: 'Файлы заключения',
  ShortProjectTitle: 'Краткое наименование проекта',
  ShortProjectTitleReason:
    'Краткое наименование проектов необходимо указать краткое (сокращенное/рабочее)               наименование проекта, которое будет использоваться для внутренней идентификации               проекта',
  TinAdressName: 'Наименование, ИНН, адрес, телефон, факс, e-mail',
  ProjectType: 'Тип проекта',
  InvalidPanoramaImage: 'Ваше изображение не может быть панорамным. Пожалуйста, загрузите другое.',
  AdditionalInfo: 'Дополнительная Информация',
  MainProject: 'Основной проект',
  SourceOfFunding: 'Источник финансирования',
  WebAddress: 'Web адрес проекта',
  LessOneBillion: 'Менее 1 миллиарда',
  MoreOneBillion: 'Более 1 миллиарда',
  ProjectTypes: 'Типы проектов',
  ProjectTags: 'Теги проекта',
  FinancingTypeProjects: 'Типы финансирования проектов',
  InitiativeCategories: 'Категории инициатив',
  ProjectIndustries: 'Отрасли проекта',
  Block: 'Блок',
  ProjectinitiatorLabel: 'Основание инициирования проекта',
  CannotDeleteThisTag: 'Удаление невозможно: данный тег используется в других проектах',
  TagWasCreatedEarlier: 'Тег был создан ранее.',
  DocumentCreationDate: 'Дата создания документа',
  Summ: 'Сум',
  NoDataForSelectedDepartment: 'Нет данных для выбранного отдела',
  Uploading: 'Загрузка...',
  FileTooLarge: 'Файл не должен превышать 10MB.',
  PanoramaRequired:
    'Загрузите изображение в панорамном формате (ширина минимум в 2 раза больше высоты).',
  PanoramaNotAllowed: 'Панорамные изображения запрещены для обычных записей.',
  FileUploadSuccess: 'Файл успешно загружен!',
  FileUploadError: 'Ошибка при загрузке файла.',
  AreYouSureMoveFileToTrash: 'Вы действительно хотите переместить этот файл в корзину',
  AreYouSureYouWantToDeleteAll: 'Вы действительно хотите удалить всё это',
  AreYouSureMoveFolderToTrash: 'Вы действительно хотите переместить эту папку в корзину',
  Restore: 'Восстановить',
  CleanFilter: 'Очистить фильтр',
  BlockName: 'Название блока',
  Permission: 'Разрешение',
  InnMustBeNumeric: 'ИНН должен состоять только из цифр',
  InnMustBe9Digits: 'ИНН должен состоять из 9 цифр',
  ReadWrite: 'Чтение/Запись',
  Read: 'Чтение',
  Disable: 'Отключено',
  SuccessfullyUpdated: 'Успешно обновлено',
  Access: 'Доступ',
  AddPermission: 'Добавить разрешение',
  AddRolePermission: 'Создать роль и назначить разрешение',
  Deputies: 'Заместители',
  Subs: 'Подчинённые',
  LeadersMultiple: 'Можно добавить несколько руководителей',
  DeputiesMultiple: 'Можно добавить несколько заместителей',
  SubsMultiple: 'Можно добавить несколько подчинённых',
  Saving: 'Сохранение...',
  CreateError: 'Произошла ошибка при создании',
  OperationError: 'Ошибка операции',
  NameRu: 'Название (Ru)',
  NameUz: 'Название (Uz)',
  EnterDepartmentName: 'Введите название отдела',
  NoChildDivisions: 'Нет дочерних отделов',
  AddChildDivision: 'Добавить подотдел',
  StructureEmpty: 'Структура пуста',
  Structure: 'Структура',
  Companies: 'Компании',
  Current: 'Текущий',
  AuthMethod: 'Способ авторизации',
  SessionDeleteConfirmation: 'Вы действительно хотите удалить эту сессию',
  SessionDeletedSuccessfully: 'Сессия успешно удалена',
  SuccessfullyCreated: 'Успешно создано',
  AreYouSureToDelete: 'Вы уверены, что хотите удалить?',
  FindByNameOrPosition: 'Найти по имени',
  ConfirmDocumentCompletion: 'Вы действительно хотите исполнить документ',
  DocumentSuccessfullySigned: 'Документ был успешно подписан',
  MarkAllAsRead: 'Прочитать всё',
  AllEmployees: 'Всего сотрудников',
  WhoYouSend: 'Кому хотите отправить',
  '#Shared#': 'Поделившийся',
  You: 'Вы',
  AllStopShare: 'Прекратить общий доступ для всех',
  MeetingNameMustAlotCharacters: 'Название встречи должно содержать от 2 до 256 символов',
  TitleStartWithLetter: 'Заголовок должен начинаться с буквы',
  Struktura:
    'Единый интегратор по созданию и поддержке государственных информационных систем - ООО "UZINFOCOM"',
  SpecialCharactersNotAllowed: 'Недопустимые спецсимволы',
  OrganizationSuccessfullyDeleted: 'Организация успешно удалена',
  CategorySuccessfullyDeleted: 'Категория успешно удалена',
  StatusSuccessfullyDeleted: 'Статус успешно удален',
  AreYouSureToDeleteAbsenceAskStatuses:
    'Вы уверены, что хотите удалить этот статус отпрашивания с работы',
  AreYouSureToDeleteAbsenceAskCategories:
    'Вы уверены, что хотите удалить эту категорию отпрашивания',
  FilterByRole: 'Фильтр по роли',
  CreateCopy: 'Создать копию',
  AreYouSureToDeleteOrganization: 'Вы уверены, что хотите удалить эту организацию',
  UploadFileCanceled: 'Загрузка файла была отменена',
  Signed: 'Подписан',
  Reviewed: 'Рассмотрен',
  Archived: 'Архивирован',
  Cancelled: 'Отменён',
  CancelShared: 'Отменить общий доступ',
  RecipientDiskNotCreated: 'Диск получателя еще не создан',
  ActualSize: 'Настоящий размер',
  PageFit: 'По размеру страницы',
  PageWidth: 'Ширина страницы',
  ItemBeforeShared: 'Повторное поделение невозможно',
  UserDiskNotCreate: 'Диск получателя пока не создан',
  Delegated: 'Передано',
  Skipped: 'Пропущено',
  AllEmployeess: 'Все сотрудники',
  CopyCreatedSuccessfully: 'Копия успешно создана',
  AskAnything: 'Спросите что-нибудь',
  ChatAI: 'Чат с ИИ',
  NewChat: 'Новый чат',
  Chats: 'Чаты',
  HowCanIHelp: 'Чем я могу вам помочь?',
  SelectCategory: 'Выберите категорию',
  ErrorAddingLeaveRequest: 'Ошибка при добавлении запроса на отпрашивание',
  UpdateSystem: 'Мы обновили систему',
  UpdateSystemDesc:
    'Мы внесли некоторые улучшения. Пожалуйста, нажмите на кнопку "Перезагрузить", чтобы изменения вступили в силу',
  Reload: 'Перезагрузить',
  ImageIsRequired: 'Изображение обязательно',
  To: 'до',
  Preview: 'Просмотр',
  WorkTimeReports: 'Отчеты по рабочему времени',
  Chats: 'Чаты',
  CreateNewGroup: 'Создать новую группу',
  Cancel: 'Отмена',
  Save: 'Сохранить',
  IncludeInAttendanceReport: 'Добавить в отчет посещаемости',
  Contacts: 'Контакты',
  Blanks: 'Бланки заявлений',
  Attachments: 'Вложения',
  DocsName: 'Название документа',
  CreatedDate: 'Дата создания',
  Employers: 'Работодатели',
  MySkud: 'Мой Скуд',
  Departments: 'Департаменты',
  Users: 'Пользователи',
  FullName: 'Полное имя',
  HrmUsers: 'Пользователи HRM',
  Actions: 'Действия',
  ConnectToHRM: 'Связать с HRM',
  AddStatus: 'Добавить статус',
  AddUser: 'Добавить пользователя',
  Roles: 'Роли',
  Add: 'Добавить',
  Submit: 'Отправить',
  Download: 'Скачать',
  Search: 'Поиск',
  Profile: 'Профиль',
  Message: 'Сообщение',
  Employees: 'Сотрудники',
  Notifications: 'Оповещения',
  FullscreenToggle: 'Вкл/выкл полный экран',
  Welcome: 'Добро пожаловать',
  WelcomeToOurCommunity: 'Добро пожаловать в наше сообщество',
  WeСreateUniqueItSolutions:
    'Мы создаём уникальные IT - решения, которые помогают обществу и нашим партнёрам достигать своих целей, обеспечивают комфорт и наполняют жизнь новыми возможностями',
  SignIn: 'Вход',
  Username: 'Имя пользователя',
  Password: 'Пароль',
  EnterLogin: 'Введите логин',
  Hint: 'Подсказка',
  Press: 'Нажмите',
  here: 'сюда',
  toShowEducationTour: 'для просмотра обучающего тура',
  Further: 'Далее',
  Previous: 'Назад',
  EnterPassword: 'Введите пароль',
  EnterUzinfocomMailLogin:
    'Введите логин, полученный от администраторов для входа в почту Uzinfocom',
  EnterUzinfocomMailPassword:
    'Введите пароль, полученный от администраторов для входа в почту Uzinfocom',
  PressButton: 'Нажмите на кнопку',
  PressThisButtonOrEnterButtonOnKeyboard:
    'Нажмите на эту кнопку или на клавишу Enter на клавиатуре компьютера',
  Today: 'Сегодня',
  InFewDays: 'Скоро',
  Greeting: 'Приветствую',
  GladToSeeYouInOurTeam: 'Рады видеть Вас в нашей команде',
  YourEnergyAndTalentWillBecomeContribution:
    'Ваша энергия и талант станут бесценным вкладом в наше общее дело',
  ForwardToNewAchievements: 'Вперед к новым свершениям',
  Start_verb: 'Начать',
  YouMustEnterUsername: 'Введите имя пользователя',
  PasswordIsTooShort: 'Слишком короткий пароль - должно быть не менее 4 символов',
  IncorrectLoginOrPassword: 'Неверное имя пользователя или пароль',
  InternalDocuments: 'Внутренние документы',
  DocumentName: 'Название документа',
  CreationDate: 'Дата создания',
  DownloadMobileApplication: 'Скачать мобильное приложение',
  HappyBirthdayСongratulations:
    'С днем рождения! Всем нашим дружным коллективом искренне поздравляем Вас со светлым, замечательным днем Вашего рождения! Желаем Вам больших успехов, постоянной удачи, везения, хорошего здоровья и бесконечного счастья в жизни. Пусть любимая работа Вам всегда приносит радость и удовольствие. Ваши профессиональные знания, большой опыт, мудрое, чуткое руководство и новые полезные идеи позволяют достигать нам в нашей совместной деятельности высоких результатов.',
  BestRegardsUzinfocomTeam: 'C уважением, команда Uzinfocom.',
  SelectPhase: 'Выберите фазу',
  GroupName: 'Название группы',
  AbsentList: 'Список отсутствующих',
  fromNumber: 'c {{val, string}}',
  untilNumber: 'по {{val, string}}',
  Claims: 'Заявки',
  DailyAttendance: 'Учёт посещений за день',
  Vacations: 'Отпуски',
  SickLeaves: 'Больничные',
  BusinessTrips: 'Командировки',
  MyDaysOff: 'Рабочие выезды и отгулы',
  LeaveRequest: 'Отпрашивание',
  AbsenceAsks: 'Рабочие выезды и отгулы',
  WorkDaysOff: 'Отпрашивания с работы',
  WorkTakeOffRequest: 'Запрос на отпрашивание с работы',
  Calendar: 'Календарь',
  GettingPermissionForEnter: 'Получение разрешения на вход',
  LoginType: 'Тип входа',
  Workload: 'Загруженность',
  BackToLoginPage: 'Вернуться на страницу входа',
  No: 'Нет',
  VisitBooking: 'Запись на приём',
  None: 'Нет',
  Top: 'Топ',
  Volonter: 'Волонтёр',
  Trainee: 'Стажёр',
  Probation: 'Испытательный срок',
  Appointment: 'Запись на приём',
  BestRegardsUzAtomTeam: 'C уважением, команда UzAtom.',
  UzAtom_fullname: 'Агентство по атомной энергии при Кабинете министров Республики Узбекистан',
  ScanFromMobileToEnter: 'Отсканируйте с мобильного приложения для входа',
  SignInWithMyId: 'Войти с помощью MyID',
  EnterUzAtomMailLogin: 'Введите логин, полученный от администраторов для входа в почту UzAtom',
  EnterUzAtomMailPassword: 'Введите пароль, полученный от администраторов для входа в почту UzAtom',
  userinfodontmatch: 'Пользователь не найден. Проверьте имя пользователя и пароль',
  Singout: 'Вы вышли из системы!',
  MyIDAuthError: 'Ошибка авторизации через MyID. Попробуйте снова',
  New: 'Новый',
  InReview: 'На подтверждении',
  Approved: 'Подтвержденный',
  StatusRejected: 'Отклоненный',
  Pending: 'Ожидание',
  TemplatesManagement: 'Управление шаблонами',
  TemplatesConstructor: 'Конструктор шаблонов',
  Back: 'Назад',
  TemplateConstructor: 'Конструктор шаблона',
  ToWhomIsAddressed: 'Кому адресовано',
  WhoToSendForApprove: 'Кому отправить на утверждение',
  AreYouSureToDeleteTemplate: 'Вы уверены, что хотите удалить шаблон?',
  TemplateSuccessfullyDeleted: 'Шаблон успешно удален',
  TemplateRejected: 'Шаблон отклонен',
  TemplateSuccessfullyApproved: 'Шаблон успешно подтвержден',
  AreYouSureToRejectTemplate: 'Вы уверены, что хотите отклонить шаблон?',
  NoApplications: 'Нет заявок',
  Accessibility: 'Доступность',
  Language: 'Язык',
  Verified: 'Подтверждён',
  Rejected: 'Отклонён',
  InputText: 'Введите текст',
  InputMultilineText: 'Введите многострочный текст',
  SelectDate: 'Выберите дату',
  InputNumber: 'Введите число',
  FillList: 'Заполните список',
  SignDocument: 'Подпишите документ',
  ScanQRCodeWithUportalApplication: 'Отсканируйте QR-код с мобильного приложения Uportal',
  NeedToSignDocument: 'Необходимо подписать документ',
  ToSign: 'Подписать',
  ToList: 'К списку',
  Note: 'Примечание',
  TableEditor: 'Редактор таблицы',
  Rows: 'Строки',
  Row: 'Строка',
  Columns: 'Столбцы',
  Application: 'Заявление',
  ApplicationBody: 'Тело заявки',
  ApprovalRoute: 'Маршрут согласования',
  TemplateFields: 'Поля шаблона',
  SignersArrayIsEmpty: 'Список согласующих лиц пуст',
  DragAndDropElementsToChangeRoute: 'Перетаскивайте элементы для изменения маршрута',
  CreatorAndHisChiefsSignatures: 'Подпись создателя и его начальников',
  ApplicantSignature: 'Подпись заявителя',
  TemplateIsEmpty: 'Шаблон пуст',
  ClickButtonToStart: 'Нажмите на кнопку ниже для добавления элемента шаблона',
  SelectEmployee: 'Выбор сотрудника',
  ApproversSignatures: 'Подписи согласующих',
  Select: 'Выбрать',
  ChooseEmployee: 'Выберите сотрудника',
  DeleteElement: 'Удалить элемент',
  AreYouSureToDeleteElement: 'Вы уверены, что хотите удалить элемент?',
  ConsecutiveRoute: 'Последовательный маршрут',
  ParallelRoute: 'Параллельный маршрут',
  Addressee: 'Адресат',
  Subtitle: 'Подзаголовок',
  Document: 'Документ',
  Documents: 'Документы',
  LoadingTemplate: 'Загрузка шаблона',
  MultilineText: 'Многострочный текст',
  ProjectsReport: 'Отчёт по проектам',
  SearchByEmployee: 'Поиск по сотруднику',
  ActualAmount: 'Фактическая сумма',
  PaymentId: 'ID платежа',
  ActualAmmount: 'Фактическая сумма',
  Paragraph: 'Параграф',
  MyDocuments: 'Мои документы',
  Hours: 'часов',
  WorkCalendar: 'Календарь рабочих дней',
  EditWorkHour: 'Редактировать рабочий час',
  DepartmentsReport: 'Отчёт за месяц',
  NonAttendances: 'Пропуски',
  Days: 'Дни',
  Reasonable: 'Уважительно',
  TotalWorkingTime: 'Общее время на работе',
  Hours: 'Часы',
  AverageTimeInBuilding: 'Среднее время нахождения в здании',
  WorkingDays: 'Рабочие дни',
  Exits: 'Выходы',
  QuantityShort: ' Кол-во',
  Minutes: 'Минуты',
  PresentWorkingDays: 'Отработанные рабочие дни (дней)',
  WorkedHoursOnWorkdays: 'Отработано в рабочие дни (часов)',
  WeekendHolidayDaysPresent: 'Выход в выходные и праздники (дней)',
  WorkedHoursOnWeekends: 'Выход в выходные и праздники (часов)',
  AverageWorkedHoursOnWeekends: 'Среднее время работы в выходные дни (часов)',
  LateArrivalCount: 'Опозданий',
  TotalLateHours: 'Опоздания (часов)',
  UnexcusedAbsenceDays: 'Пропуск (дни)',
  ExcusedAbsenceDays: 'Пропуски с причиной (дни)',
  TotalDurationHours: 'Общее время на работе (часы)',
  BusinessTripDays: 'Командировка (дней)',
  WorkTrip: 'Командировка',
  VacationDays: 'Отпуск (дней)',
  SickLeaveDays: 'Больничние дни',
  NoAvailableDepartments: 'Нет доступных подразделений',
  TOP: 'ТОП',
  TotalWorkingDays: 'Общее количество рабочих дней',
  TotalWorkingHours: 'Общее количество рабочих часов',
  AverageWorkedHoursOnWorkdays: 'Среднее время работы в рабочие дни (часов)',
  TOPS: 'ТОПы',
  DocumentChecking: 'Проверка документа',
  CheckSignatures: 'Проверить подписи',
  EnterDocumentId: 'Введите идентификатор документа',
  WithoutStatus: 'Без статуса',
  ProjectsDashboard: 'Дашборд по проектам',
  Last10Projects: 'Последние 10 проектов',
  Subdivision: 'Подразделение',
  ShowTopManager: 'Показать ТОП-менеджера',
  CreateProject: 'Создать проект',
  Fulfilled: 'Исполненные',
  BlocksDailyReport: 'Отчёт по блокам за сутки',
  NoData: 'Нет данных',
  ExpandAll: 'Развернуть все',
  Post: 'Должность',
  SummaryReportForOneDay: 'Сводный отчёт за сутки',
  TotalEmployees: 'Всего сотрудников',
  ComingToWork: 'Приход на работу',
  Latecomers: 'Опоздавшие',
  LateCome: 'Опоздал(а)',
  EarlyLeft: 'Ранние уходы',
  Absent: 'Отсутствующие',
  WithoutReason: 'Без ув. причины',
  OnVacation: 'В отпуске',
  OnBusinessTrip: 'В командировке',
  OnSickLeave: 'На больничном',
  OnNumber: 'на {{count}}',
  Violation: 'Нарушение',
  Lateness: 'Опоздание',
  EarlyLeaving: 'Ранний уход',
  AbsenceOnWork: 'Отстутствие на работе',
  LateTimeOn:
    'Опоздание на {{hours}} {{hours_label}} {{minutes}} {{minutes_label}} {{seconds}} {{seconds_label}}',
  EarlyLeavingOn:
    'Уход раньше на {{hours}} {{hours_label}} {{minutes}} {{minutes_label}} {{seconds}} {{seconds_label}}',
  hour_one: 'час',
  hour_few: 'часа',
  hour_many: 'часов',
  minute_one: 'минуту',
  minute_few: 'минуты',
  minute_many: 'минут',
  second_one: 'секунду',
  second_few: 'секунды',
  second_many: 'секунд',
  SkudStatistics: 'СКУД. Статистика',
  FromDate: 'С какого числа',
  ToDate: 'По какое число',
  CameToOffice: 'Пришли в офис',
  SickBusinessTimeOff: 'Больничные/командировки/отгулы',
  Lates: 'Опоздания',
  LatesAndEarlyLeavings: 'Опоздания и ранние уходы',
  EarlyLeavings: 'Ранние уходы',
  WithoutReasons: 'Без причины',
  StatisticsByBlocks: 'Статистика по блокам',
  ClaimDataUnavailable: 'Информация о заявке недоступна',
  Edit: 'Редактировать',
  LocalNormativeActs: 'Локальные нормативные акты',
  Finish: 'Завершить',
  ChooseDocument: 'Выберите документ',
  AssignSelectedDocument: 'Назначить выбранный документ',
  CheckInformationAndPublish: 'Проверьте и подтвердите',
  AdditionalInformation: 'Дополнительная информация',
  UploadNew: 'Загрузить',
  MandatoryConfirmation: 'Обязательное подтверждение',
  Monitoring: 'Мониторинг',
  SelectDocument: 'Выберите документ',
  AssignedEmployees: 'Назначено сотрудников',
  Confirmed: 'Подтвердили',
  NotConfirmed: 'Не подтвердили',
  CompletionPercent: 'Процент выполнения',
  Department: 'Департамент',
  Division: 'Отдел',
  division: 'отдел',
  Group: 'Группа',
  Position: 'Должность',
  EmployeeSearch: 'Поиск по ФИО',
  ToSign: 'Подписать',
  PendingSignature: 'На подписи',
  Signed: 'Подписанные',
  WhoHas: 'У кого',
  Sign: 'Подписать',
  Rejected_plural: 'Отклонённые',
  NoDocuments: 'Нет документов',
  ArchiveDocuments: 'Архивные документы',
  DisconnectFromHRM: 'Отвязать от HRM',
  NoActionsAvailable: 'Нет доступных действий',
  UploadDocument: 'Загрузите документ',
  DocumentSignatureType: 'Тип подписания документа',
  DaysUntilDeadline: 'Дней до дедлайна',
  SendToAll: 'Отправить всем',
  FileIsRequired: 'Необходимо указать файл',
  SelectFile: 'Выберите файл',
  ForFamiliarization: 'На ознакомление',
  ForSigning: 'На подпись',
  AreYouSureToDeleteDocument: 'Вы уверены, что хотите удалить документ?',
  DocumentSuccessfullyDeleted: 'Документ успешно удален',
  SelectedDocuments: 'Выбранные документы',
  DocumentTitle: 'Название документа',
  DocumentDescription: 'Описание документа',
  ToWhomToAssignSelectedDocuments: 'Кому назначить выбранные документы',
  CheckAndSend: 'Проверьте данные и нажмите "Отправить"',
  SearchByDepartmentsAndEmployees: 'Поиск по подразделениям и сотрудникам',
  DocumentSuccessfullySent: 'Документ успешно отправлен',
  DocumentVersions: 'Версии документа',
  ShowDocumentVersions: 'Показать версии документа',
  DocumentInformation: 'Информация о документе',
  YouNeedToSignDocumentToContinueUsingSystem:
    'У вас есть документ, обязательный для ознакомления/подписи. Необходимо ознакомиться/подписать данный документ для продолжения работы в системе',
  NumberOfAssignedEmployees: 'Количество сотрудников, которым назначен документ',
  DocumentSuccessfullySigned: 'Документ успешно подписан',
  ToFamiliarize: 'Ознакомиться',
  Version: 'Версия',
  LNAManagement: 'Управление ЛНА',
  FileSuccessfullyUploaded: 'Файл успешно загружен',
  ChoosePdfFile: 'Выберите pdf документ',
  UploadNewDocumentVersion: 'Загрузка новой версии документа',
  DocumentSuccessfullyUpdated: 'Документ успешно обновлен',
  DocumentStatus: 'Статус документа',
  Rejected_male: 'Отклонён',
  ShowChangesHistory: 'Показать историю изменений',
  ChangesHistory: 'История изменений',
  Template: 'Шаблон',
  ViewNews: 'Посмотреть новости',
  InPending: 'В ожидании',
  Familiarized_plural: 'Ознакомленные',
  Approved_plural: 'Подтвержденные',
  Signed_plural: 'Подписанные',
  AboutDocument: 'О документе',
  StructureIsNotFetched: 'Не удалось загрузить структуру компании.',
  UpdatingList: 'Обновление списка…',
  AlreadyChosen: ' • уже выбран в другой группе',
  Current_female: 'Текущая',
  ToOpen: 'Открыть',
  AllDocumentsSuccessfullySent: 'Все документы успешно отправлены',
  FieldIsRequired: 'Это поле обязательно для заполнения',
  InternalWorkflow: 'Внутренний документооборот',
  ApplicantSignature: 'Подпись заявителя',
  ChooseApplicationType: 'Выберите тип заявления',
  NotFound: 'Не найдено',
  SelectStartAndEndDatesToGetDataFromSkud:
    'Выберите даты начала и окончания для получения данных из СКУД',
  ExecuteRequest: 'Выполнить запрос',
  GetAttendanceByDateRange: 'Получить данные со СКУД',
  AttendanceDataRequestedWaitForNotification:
    'Данные запрошены. После выполнения запроса Вам придёт уведомление',
  Share: 'Поделиться',
  EnterKeyWordField: 'Введите ключевое слово для поля',
  SelectTag: 'Выберите тег',
  SelectTag: 'Выберите тег',
  NoOptions: 'Нет вариантов',
  PortalTechSupport: 'Тех. поддержка портала',
  PortalTechnicalSupport: 'Техническая поддержка корпоративного портала',
  NoTodayBirthdays: 'Сегодня нет именинников',
  NoIncomingBirthdays: 'В ближайшие дни нет именинников',
  HappyBirthdayText:
    'От всей души поздравляем вас с этим замечательным днём! Желаем крепкого здоровья, счастья, успехов во всех начинаниях, вдохновения и позитивных эмоций. Пусть каждый день приносит радость, а мечты становятся реальностью!',
  HappyBirthday: 'С днём рождения',
  DayReport: 'Отчёт за день',
  MonthReport: 'Отчёт за месяц',
  AttendanceReportMonth: 'Отчёт по посещаемости за месяц по отделам',
  AttendanceReportADay: 'Отчёт по посещаемости за день по отделам',
  SummaryByDepartment: 'Общая статистика по отделам за выбранный день',
  SummaryByDepartmentAMonth: 'Сводная статистика по всем блокам компании за выбранный период',
  EmployeesReport: 'Отчёт по посещаемости сотрудников за день',
  EmployeeStatistics: 'Статистика сотрудников',
  ByBlocks: 'По блокам',
  ByEmployees: 'По сотрудникам',
  OnDate: 'на',
  DetailedDepartmentCards: 'Детализированные карточки по отделам',
  AggregatedDepartmentAttendance:
    'Агрегированная информация по посещаемости отделов за выбранный месяц',
  AreYouSureDeleteCategory: 'Вы действительно хотите удалить эту категорию',
  DocumentCategories: 'Категории документов',
  MainCategory: 'Главная категория',
  NoParent: 'Нет родительской категории',
  NoMainCategory: 'Нет основной категории',
  AddSubcategory: 'Добавить подкатегорию',
  AttachAdditionalFile: 'Приложить дополнительный файл',
  PreviewApplicationDesc: `Заполните необходимые поля формы и нажмите на кнопку "Предпросмотр" для предварительного просмотра документа`,
  PreviewApplication: 'Предпросмотр',
  SelectDay: 'Выберите день',
  TopManagementReportDesc: 'Мониторинг посещений топ-менеджмента через СКУД',
  AttendancePercentage: 'Процент присутствия',
  OverallAttendanceStatistics: 'Общая статистика посещаемости',
  EventSuccessfullyUpdated: 'Мероприятие успешно обновлено',
  MyCalendars: 'Мои календари',
  EditCalendarEvent: 'Редактирование события календаря',
  AddCalendarEvent: 'Добавление события календаря',
  Hybrid: 'Гибрид',
  MyTasks: 'Мои задачи',
  ProjectTasks: 'Задачи проекта',
  TaskName: 'Название задачи',
  Date: 'Дата',
  StartTime: 'Время начала',
  EndTime: 'Время окончания',
  TimeZone: 'Часовой пояс',
  Members: 'Участники',
  Guests: 'Гости',
  Description: 'Описание',
  Reminder: 'Напоминание',
  AddReminder: 'Добавить напоминание',
  NotificationMethod: 'Метод уведомления',
  PushNotification: 'Push уведомление',
  Add: 'Добавить',
  SelectCalendar: 'Выберите календарь',
  AllDay: 'Весь день',
  Repeat: 'Повторять',
  AddMember: 'Добавить участника',
  AddGuest: 'Добавить гостя',
  Cabinet: 'Кабинет',
  Link: 'Ссылка',
  Add: 'Добавить',
  SelectCalendar: 'Выберите календарь',
  AllDay: 'Весь день',
  Repeat: 'Повторять',
  Tasks: 'Задачи',
  MyEvents: 'Мои мероприятия',
  Event: 'Мероприятие',
  FileAttachments: 'Прикрепление файлов',
  Upload: 'Загрузить',
  MyCalendarBeta: 'Мой календарь (beta)',
  HrmOrderType: 'Тип приказа в HRM',
  SelectHrmOrderType: 'Выберите тип приказа в HRM',
  NoTemplateFields: 'Нет полей шаблона',
  EndWorkingTime: 'Рабочее время (конец)',
  StartWorkingTime: 'Рабочее время (начало)',
  WorkedDays: 'Рабочее время (начало)',
  OutgoingDocuments: 'Исходящие документы',
  SelectResource: 'Выберите ресурс',
  BirthdayCardWillBeClosed:
    'Карточка с поздравлениями будет закрыта до следующей авторизации в системе',
  Acquainted_plural: 'Ознакомились',
  Signed_plural: 'Подписали',
  CreatedOnes: 'Созданные',
  SignedOnes: 'Подписанные',
  NotSignedOnes: 'Не подписанные',
  RejectedOnes: 'Отклонённые',
  ArchiveOnes: 'Архивные',
  ForExecutionOnes: 'На исполнение',
  CompletedOnes: 'Завершённые',
  Signed_plural: 'Подписали',
  CreateDocumentsWithAutomaticApprovalRoute:
    'Создавайте внутренние документы с автоматическим маршрутом согласования',
  CreatingDocuments: 'Создание документов',
  CreateDocument: 'Создать документ',
  Archive: 'Архив',
  CreatingDocument: 'Создание документа',
  AttendanceReport: 'Отчёт о посещаемости',
  Completed: 'Выполнено',
  NoTemplate: 'Нет шаблона',
  Show: 'Показать',
  NoTemplate: 'Нет шаблонов',
  AvgHours: 'Среднее время на работе (часов)',
  SyncReferences: 'Синхронизировать справочники',
  SyncOrderTypesReferences: 'Синхронизировать справочники типов приказов',
  ReferencesSuccessfullySynchronized: 'Справочники успешно синхронизированы c HRM',
  ReferencesSynchronizationError: 'Ошибка при синхронизации справочников',
  Synchronization: 'Синхронизация',
  ItIsNecessaryToAttachFile:
    'Согласно выбранному шаблону для данного типа документа необходимо приложить файл(ы)',
  AttachFile: 'Приложите файл',
  ConfirmationOfDeletion: 'Подтверждение удаления',
  AreYouSureToDeleteSubcategory:
    'Вы действительно хотите удалить выбранную категорию? Все связанные с ней шаблоны также будут удалены',
  VisitType: 'Статус посещаемости',
  LateAndEarlyLeaving: 'Опоздал(а) и ушёл(ла) рано',
  ReasonAbsent: 'Отсутствие по уважительной причине',
  Absent_s: 'Отсутствует',
  EarlyLeaving_s: 'Ушёл(ла) рано',
  MyTasksIsEmpty: 'Задачи не найдены',
  MyTasksIsEmptyDescription: 'На выбранный период ничего не запланировано',
  OnlineEvent: 'Онлайн',
  OfflineEvent: 'Офлайн',
  HybridEvent: 'Гибридный',
  DeadlineDate: 'Дата дедлайна',
  DateAndTime: 'Дата и время',
  EventDetails: 'Детали события',
  EventDescription: 'Описание события',
  SelectColor: 'Выберите цвет',
  SelectIcon: 'Выбрать иконку',
  OutOffice: 'Вне офиса',
  WhoCompleteTable: 'Кем заполняется данная таблица',
  PersonalReasons: 'Отгулы',
  OnBusinessMeeting: 'Рабочие выезды',
  OnlyPDFAllowed: 'Только файлы формата PDF',
  MaxFileSizeExceeded: 'Размер файла больше 5 МБ',
  FilesSuccessfullyAdded: 'Файл успешно добавлен',
  CreateCalendar: 'Создать календарь',
  CalendarSettings: 'Настройки календаря',
  CalendarTitle: 'Название календаря',
  LayerColor: 'Цвет слоя',
  CalendarIcon: 'Иконка календаря',
  CalendarType: 'Тип календаря',
  CalendarType_personal: 'Личный',
  CalendarType_team: 'Командный',
  CalendarType_corp: 'Корпоративный',
  AccessRights: 'Права доступа',
  Access_onlyMe: 'Только я',
  Access_team: 'Моя команда',
  Access_department: 'Весь отдел',
  Access_company: 'Вся компания',
  ValueMustBeMoreThanZero: 'Значение должно быть больше 0',
  LastUpdated: 'Время последнего обновления базы данных: {{lastUpdatedAt}}'
};

export default locale;
